/* Layout */
import { RouteConfig } from 'vue-router'
import { iArray } from '@/common/utils'
import MonitorRoutes from './modules/monitor'
const UserList = () => import('@/views/user/list.vue')
const UserAuthentications = () => import('@/views/user/authentications.vue')
const UserDetail = () => import('@/views/user/detail.vue')
const ContactOrder = () => import('@/views/order/list.vue')
const ViewPhone = () => import('@/views/permission/viewPhone.vue')
const AdminUsers = () => import('@/views/permission/users.vue')
const AdminUserCreate = () => import('@/views/permission/create.vue')
const AdminUserEdit = () => import('@/views/permission/edit.vue')
const DeleteNews = () => import('@/views/permission/deleteNews.vue')
const AiModelApi = () => import('@/views/system/aiModel/api/index.vue')
const AiFeatureBinding = () => import('@/views/system/aiModel/feature/index.vue')
const AiChatLog = () => import('@/views/system/aiModel/log/index.vue')

// 直接导入为 undifened
const Layout = () => import('@/layout/index.vue')

// 管理员路由
const adminRoutes: RouteConfig[] = [{
    path: '/user',
    component: Layout,
    redirect: '/user/list',
    meta: {
        title: '用户',
        icon: 'icon-user',
        alwaysShow: true // will always show the root menu
    },
    children: [{
        path: 'list',
        component: UserList,
        name: 'UserList',
        meta: {
            title: '用户列表'
        }
    }, {
        path: 'authentications',
        component: UserAuthentications,
        name: 'UserAuthentications',
        meta: {
            title: '用户认证'
        }
    }, {
        path: ':id',
        component: UserDetail,
        name: 'UserDetail',
        meta: {
            title: '用户详情',
            hidden: true
        }
    }]
}, {
    path: '/permission',
    component: Layout,
    meta: { 
        title: '权限管理', 
        icon: 'icon-quanxian',
        alwaysShow: true // will always show the root menu
    },
    children: [{
        path: 'phone',
        component: ViewPhone,
        name: 'ViewPhone',
        meta: { 
            title: '查看手机号' 
        }
    }, {
        path: 'detelenews',
        component: DeleteNews,
        name: 'DeleteNews',
        meta: { 
            title: '查看删除新闻' 
        }
    },{
        path: 'users',
        component: AdminUsers,
        name: 'AdminUsers',
        meta: { 
            title: '庖丁账号管理' 
        }
    }, {
        path: 'user/create',
        component: AdminUserCreate,
        name: 'AdminUserCreate',
        meta: { 
            title: '庖丁账号创建',
            hidden: true
        }
    }, {
        path: 'user/:id',
        component: AdminUserEdit,
        name: 'AdminUserEdit',
        meta: { 
            title: '庖丁账号编辑',
            hidden: true
        }
    }]
}, {
    path: '/order',
    component: Layout,
    children: [{
        path: '',
        component: ContactOrder,
        name: 'ContactOrder',
        meta: {
            title: '订单列表',
            icon: 'icon-order'
        }
    }]
}, {
    path: '/ai-model',
    component: Layout,
    redirect: '/ai-model/api',
    meta: {
        title: '大模型',
        icon: 'icon-others',
        alwaysShow: true
    },
    children: [{
        path: 'api',
        component: AiModelApi,
        name: 'AiModelApi',
        meta: {
            title: '大模型 API'
        }
    }, {
        path: 'feature',
        component: AiFeatureBinding,
        name: 'AiFeatureBinding',
        meta: {
            title: '模型功能绑定'
        }
    }, {
        path: 'log',
        component: AiChatLog,
        name: 'AiChatLog',
        meta: {
            title: '模型运行日志'
        }
    }]
},
/* 监测后台 - 模块一 P2 骨架：独立框架 + 5 个子页面（仅 01 模块一实现） */
MonitorRoutes]


/**
 * 根据路由 name 查找对应的路由配置
 * @date 2021-11-08
 * @param {any} routeNames:string[]
 * @returns {any}
 */
function findAdminRoutes(routeNames: string[]): RouteConfig[] {
    const result = {}
    const cloneNames = [...routeNames]
    for(let i = 0; i < adminRoutes.length; i++) {
        const route = adminRoutes[i]
        if (route.children) {
            for(let j = 0; j < route.children.length; j++) {
                const childRoute = route.children[j]
                if (childRoute.name && cloneNames.includes(childRoute.name)) {
                    const isExist = Reflect.get(result, route.path)
                    if (isExist) {
                        const children = Reflect.get(result, route.path)
                        children.push(childRoute)
                    } else {
                        Reflect.set(result, route.path, {
                            ...route,
                            children: [
                                childRoute
                            ]
                        })
                    }
                    iArray.remove(childRoute.name, cloneNames)
                    if (!cloneNames.length) {
                        break
                    }
                }
            }
        }
    }

    return Object.values(result)
}

/**
 * 检查是否需要显示在侧边栏
 * @date 2021-11-08
 * @param {any} route:RouteConfig
 * @returns {any}
 */
function filterIsVisible(route: RouteConfig) {
    let hidden = true
    if (route.children) {
        route.children.some(child => {
            // 只要有一个 child.meta.hidden 判断为 false
            // 退出循环
            if (!child.meta.hidden) {
                hidden = true
                // 终止循环
                return true
            }
        })
    }
    route.meta.hidden = hidden
}

export {
    findAdminRoutes,
    filterIsVisible
}

export default adminRoutes
